let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8BNM8")).then(() => parcelRequire('6Sdjr'));